import InternalDropdown from './dropdown';
import DropdownButton from './dropdown-button';
const Dropdown = InternalDropdown;
Dropdown.Button = DropdownButton;
export default Dropdown;
